var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 176,
    viewBox: "0 0 400 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.21 12.89H33.79C15.1283 12.89 0 28.0183 0 46.68V142.17C0 160.832 15.1283 175.96 33.79 175.96H366.21C384.872 175.96 400 160.832 400 142.17V46.68C400 28.0183 384.872 12.89 366.21 12.89Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366.21 3.96997H33.79C15.1283 3.96997 0 19.0983 0 37.76V133.25C0 151.912 15.1283 167.04 33.79 167.04H366.21C384.872 167.04 400 151.912 400 133.25V37.76C400 19.0983 384.872 3.96997 366.21 3.96997Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.21 0H33.79C15.1283 0 0 15.1283 0 33.79V129.28C0 147.942 15.1283 163.07 33.79 163.07H366.21C384.872 163.07 400 147.942 400 129.28V33.79C400 15.1283 384.872 0 366.21 0Z",
    fill: "url(#paint0_radial_8816_20233)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1201 53.26C5.86005 52.44 0.170051 40.74 6.07005 32.31C12.1801 23.57 22.3101 17.85 33.7901 17.85H366.21C377.69 17.85 387.83 23.57 393.93 32.32C399.84 40.78 394.11 52.45 383.83 53.28C378.73 53.69 373.01 54.05 366.79 54.28C278.91 57.56 264.18 28.54 200.25 28.51C136.37 28.48 121.78 57.44 33.7101 54.28C27.2801 54.05 21.3801 53.68 16.1301 53.26H16.1201Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.88 110.08C394.14 110.9 399.83 122.6 393.93 131.03C387.82 139.77 377.69 145.49 366.21 145.49H33.79C22.31 145.49 12.17 139.77 6.07003 131.02C0.160026 122.56 5.89003 110.89 16.17 110.06C21.27 109.65 26.99 109.29 33.21 109.06C121.09 105.78 135.82 134.8 199.75 134.83C263.63 134.86 278.22 105.9 366.29 109.06C372.72 109.29 378.62 109.66 383.87 110.08H383.88Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400 33.78V47.66C400 29 384.87 13.88 366.22 13.88H33.78C15.12 13.88 0 29.01 0 47.66V33.78C0 15.12 15.13 0 33.78 0H366.21C384.87 0 399.99 15.13 399.99 33.78H400Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400 115.41V129.29C400 147.95 384.87 163.07 366.22 163.07H33.78C15.12 163.07 0 147.94 0 129.29V115.41C0 134.07 15.13 149.19 33.78 149.19H366.21C384.87 149.19 399.99 134.06 399.99 115.41H400Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.83 50.31C171.76 78.88 167.91 94.92 127.88 94.92C87.85 94.92 18.4299 86.23 7.92995 50.31C7.86995 50.1 7.80995 49.87 7.80995 49.87C3.76995 35.37 9.69995 20.32 13.8799 14.62C21.9999 3.57 39.8899 5.48001 66.4199 6.69001C99.7599 8.21001 133.18 5.86001 166.54 6.69001C187.39 7.21001 205.56 7.37 241.88 7.68C336.87 8.5 365.04 5.8 365.8 10.65C366.77 16.87 320.76 22.91 247.83 50.3V50.31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.53 45.35C140.42 63.26 120.11 76.67 91.2 78.06C60.74 79.52 19.3 67.71 14.87 45.35C12.9 35.41 18.91 26.8 19.83 25.52C30.68 10.43 53.53 11.62 91.21 12.63C172.65 14.81 192.49 12.63 194.31 20.56C195.73 26.73 185.05 33.78 167.54 45.34L167.53 45.35Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4 34.35C79.4 43.6 68.92 50.52 53.99 51.24C38.27 52 16.87 45.9 14.58 34.35C13.56 29.22 16.66 24.77 17.14 24.11C22.74 16.32 34.54 16.94 53.99 17.46C96.04 18.59 106.28 17.46 107.22 21.55C107.95 24.73 102.44 28.38 93.4 34.35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8816_20233",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.21 19.5738) scale(333.83 153.562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99E2EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton1);
export default __webpack_public_path__ + "static/media/button_1.6033dfb5b2f4bd69e4ae6d4b13f20828.svg";
export { ForwardRef as ReactComponent };